export default "__VITE_ASSET__BU_j6E0c__"